
import { createAction, props } from '@ngrx/store';

export const loadBrokerFormConfigData = createAction('[Data BrokerFormConfig API] Load Data',);
export const loadBrokerFormConfigDataSuccess = createAction('[Data BrokerFormConfig API] Load Data Success', props<any>());
export const loadBrokerFormConfigDataFailure = createAction('[Data BrokerFormConfig API] Load Data Failure', props<any>());
